export const style = {
    frame: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      color: 'rgb(128,128,128)',
    },
    label: {
      textAlign: 'center',
      fontSize: '48px',
    },
    leave: {
      border: '2px solid grey',
      backgroundColor: 'rgb(230,230,230)',
      color: 'rgb(128,128,128)',
    },
    enter: {
      border: '2px dashed grey',
      backgroundColor: 'rgb(200,200,200)',
      color: 'rgb(64,64,64)',
    },
};
